import { FC, FormEvent, useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Input } from "@/components/ui/input";
import { Inventory } from "@/interface/entityInterface";

interface Props {
  data: Inventory[];
  setData: React.Dispatch<React.SetStateAction<Inventory[]>> | Function;
}

const InventoryTable: FC<Props> = ({ data, setData }) => {
  const [totalPrice, setTotalPrice] = useState<number>(0);

  useEffect(() => {
    const total = data.reduce((acc, item) => acc + (item.price * (item.quantity || 1) || 0), 0);
    setTotalPrice(total);
  }, [data]);

  return (
    <div className="mt-5 max-h-60 overflow-y-auto w-full">
      {data && data.length > 0 && (
        <Table className="min-w-full table-auto">
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Quantity</TableHead>
              <TableHead className="text-right pr-8">Price per unit</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody className="w-full">
            {data &&
              data.map((item) => (
                <TableRow key={item.id}>
                  <TableCell className="w-full text-left">
                    {item.name} {`(${item.unit})`}
                  </TableCell>
                  <TableCell>
                    <Input
                      min={1}
                      className="w-20 text-right"
                      onChange={(e: FormEvent<HTMLInputElement>) =>
                        setData((prev: any[]) =>
                          prev.map((i) =>
                            i.id === item.id
                              ? { ...i, quantity: +e.currentTarget.value }
                              : i,
                          ),
                        )
                      }
                      id="quantity"
                      type="number"
                      value={item.quantity || 1}
                    />
                  </TableCell>
                  <TableCell>
                    <Input
                      min={1}
                      className="w-20 text-right"
                      onChange={(e: FormEvent<HTMLInputElement>) =>
                        setData((prev: any[]) =>
                          prev.map((i) =>
                            i.id === item.id
                              ? { ...i, price: +e.currentTarget.value }
                              : i,
                          ),
                        )
                      }
                      id="price"
                      type="number"
                      value={item.price || ""}
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
          <TableFooter className="sticky bottom-0">
            <TableRow>
              <TableCell className="text-left">Total</TableCell>
              <TableCell></TableCell>
              <TableCell>
                <Input
                  min={1}
                  className="w-20 text-right"
                  id="total"
                  type="text"
                  value={totalPrice + "$"}
                  readOnly
                />
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      )}
    </div>
  );
};

export default InventoryTable;
